
/*eslint-disable */

import Multiselect from 'vue-multiselect';
import {bus} from '@/main';
import toast from '@/services/toast';
export default {
  name: 'candidates-linkage-with-q-bank-popup',
  components: {
    Multiselect
  },
  props: ['candidateID'],
  data () {
    return {
      qBankData:null,
      qbankRslts:[],
      selectedQBank:'',
      isSubmitted:false,
      linkageQBankInfo:null,
      linkageQBankInfoRslts:[],
    }
  },
  computed: {

  },
  mounted () {
    this.$store.dispatch('getQBankInfoAction').then((res) => {
        this.qBankData = res.data.data
        this.qbankRslts = this.qBankData.results
    })
  },
  methods: {
    closeLinkageQBankPopupMethod(){
      bus.$emit('candidateLinkagePopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    linkgaeQBankSubmitMehtod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.isSubmitted = true
          let data = {
            candidate:this.candidateID,
            question_bank:this.selectedQBank.id
          }
          this.$store.dispatch('postQueBankWithCandiatesInfoAction', data).then((res) => {
            this.isSubmitted = false;
            toast.success(res.data.msg || "Request has been successfully submitted");  
            this.closeLinkageQBankPopupMethod();
          }).catch((err) => {
            this.isSubmitted = false;
            toast.error(err.data.data.error || err.data.msg);
          })
          return;
        }
      })
    },
  }
}


